import React, { useId } from 'react';

const sizeMap = {
  sm: {
    icon: 24,
    gap: 'gap-2.5',
    title: 'text-base',
    subtitle: 'text-[9px]',
  },
  md: {
    icon: 32,
    gap: 'gap-3',
    title: 'text-lg',
    subtitle: 'text-[10px]',
  },
  lg: {
    icon: 48,
    gap: 'gap-4',
    title: 'text-2xl',
    subtitle: 'text-xs',
  },
};

function ShieldMark({ size }) {
  const gradientId = useId().replace(/:/g, '');

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="flex-shrink-0"
    >
      <defs>
        <linearGradient id={gradientId} x1="14" y1="10" x2="50" y2="54" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B82F6" />
          <stop offset="1" stopColor="#8B5CF6" />
        </linearGradient>
      </defs>
      <path
        d="M32 7L50 13V27.2C50 38.95 42.83 49.53 32 55C21.17 49.53 14 38.95 14 27.2V13L32 7Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M32 11.5L46 16.17V27.14C46 35.79 40.76 43.61 32 48.32C23.24 43.61 18 35.79 18 27.14V16.17L32 11.5Z"
        stroke="rgba(255,255,255,0.18)"
        strokeWidth="1.5"
      />
      <path
        d="M19 33H25L29 25L34 39L39 29H45"
        stroke="white"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Logo({ size = 'md', showText = true }) {
  const config = sizeMap[size] || sizeMap.md;

  return (
    <div className={`flex items-center ${config.gap}`}>
      <ShieldMark size={config.icon} />
      {showText && (
        <div className="min-w-0">
          <div className={`${config.title} font-bold tracking-wider text-white leading-none`}>ASM</div>
          <div className={`${config.subtitle} mt-1 text-slate-400 leading-none`}>SecureOps</div>
        </div>
      )}
    </div>
  );
}
